import { MenuEntry } from '@likeswaporg/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },
    {
    label: 'Exchange',
    icon: 'TradeIcon',
    href: 'https://app.likeswap.org/#/swap',
  },
      {
    label: 'Liquidity',
    icon: 'NftIcon',
    href: 'https://app.likeswap.org/#/pool',
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: '/farms',
  },
  {
    label: 'Pools',
    icon: 'PoolIcon',
    href: '/pools',
  },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  {
    label: 'Lottery',
    icon: 'TicketIcon',
    href: '/lottery',
    // href: '',
  },
  {
    label: 'IFO',
    icon: 'IfoIcon',
    href: '/ifo',
    // href: '',
  },
  {
    label: 'Referrals',
    // icon: 'ReferralsIcon',
    icon: 'GroupsIcon',
    href: '/referrals',
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    href: 'https://info.likeswap.org/',
  },
  {
    label: 'Tool',
    icon: 'MoonIcon',
    href: 'https://tool.likeswap.org/',
  },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: '/nft',
  // },
  {
    label: 'Price Graph',
    // icon: 'ReferralsIcon',
    icon: 'SunIcon',
    href: 'https://info.likeswap.org/token/0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
  },
    //  {
    //    label: 'Dapp Radar',
	// icon: 'MoreIcon',
    //    href: 'https://dappradar.com/binance-smart-chain/defi/likeswap',
    //  },
     // {
    //    label: 'PancakeSwap',
	// icon: 'MoreIcon',
    //    href: 'https://pancakeswap.info/token/0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
     // },
    //  {
      //  label: 'BSCScan',
	// icon: 'MoreIcon',
     //   href: 'https://bscscan.com/token/0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
      // },  
   
      {
        label: 'Docs',
	icon: 'MoreIcon',
        href: 'https://docs.likeswap.org/',
      },
      {
        label: 'Medium',
	icon: 'MoreIcon',
        href: 'https://likeswap.medium.com/',
      },
         {
        label: 'Github',
	icon: 'MoreIcon',
        href: 'https://github.com/likeswap/',
      },
 
    {
    label: 'Audit by TechRate',
    icon: 'AuditIcon',
    href: 'https://github.com/LikeSwap/farms/blob/main/files/TechRateAudit.pdf',
  },
  {
    label: 'Audit by Hacken',
    icon: 'AuditIcon',
    href: 'https://github.com/LikeSwap/farms/blob/main/files/hackenAudit.pdf',
  },
  {
   label: 'Contact',
    icon: 'AuditIcon',
    href: 'https://docs.likeswap.org/community-social/contact',
},
]

export default config